import { camelCase, titleCase } from "change-case";
import { ITypeahead, ISearch } from "../models";
import { groupBy, deepCopy } from "./";

export function getTypeaheadResults(allValues: ITypeahead[], term: string, searchValues: string[], advancedFilterValues: ISearch[], notExplorer: boolean = false): ITypeahead[] {
	let response = [];
	let allValuesCopy = deepCopy(allValues);
	let filteredValues = [...allValuesCopy].filter((item) => {
		let candidateTerms = item.searchable.split("|");
		let [isCandidateTerm] = candidateTerms
			.map(ct => ct.indexOf(term.toUpperCase()) >= 0)
			.filter(ctBool => ctBool);

		if (isCandidateTerm) {
			let isAdvancedFilterSet = [];
			for (let filterOptions of advancedFilterValues) {
				isAdvancedFilterSet.push(filterOptions.values.indexOf(item.display[filterOptions.property] as string) >= 0);
			}

			if (notExplorer) {
				if (isAdvancedFilterSet.indexOf(false) === -1) {
					return item;
				}
			}
			else {
				if (isAdvancedFilterSet.indexOf(true) <= 0) {
					return item;
				}
			}
		}
	});

	let groupedValues = groupBy(filteredValues, (value) => camelCase(value.display.fund_name));
	Object.keys(groupedValues).map(key => {
		let suggestion = {
			title: groupedValues[key][0].display.legal_name,
			suggestions: [...groupedValues[key]]
		};
		response.push(suggestion);
	});

	return response;
}


// WEBPACK FOOTER //
// ./src/client/utils/typeahead.ts